var exports = {
  "D": "x61f99309--c16824--title",
};

module.exports = exports;
